import { JourneyAncillary, MealInfo, SegmentAncillary } from '@/src/types/itinerary'
import { isEmpty } from '../../generalUtils/isEmpty'
import { AncillaryDataStructure, processAncillaryData } from './common'

// ================================
// MEAL PROCESSING
// ================================

/**
 * Extracts meal data from segment ancillary
 */
const extractMealData = (segmentAncillary: SegmentAncillary) => {
    const { mealAncillaries, originDestinationInfo } = segmentAncillary || {}
    const { mealInfos = [] } = mealAncillaries || {}

    if (!Array.isArray(mealInfos) || isEmpty(mealInfos)) {
        return null
    }

    return { data: mealInfos, originDestinationInfo }
}

/**
 * Processes meal ancillaries
 */
export const getMealAncillaries = (journeyAncillaries: JourneyAncillary[]) => {
    const mealAncillaries = processAncillaryData<MealInfo>(journeyAncillaries, extractMealData)

    return {
        mealAncillaries,
        isMealAvailable: mealAncillaries.availableSegments.length > 0
    }
}

/**
 * Finds meal object by code within a specific segment
 */
export const findMealByCode = (
    mealCode: string,
    segmentKey: string,
    mealAncillaries: AncillaryDataStructure<MealInfo[]>
): MealInfo | null => {
    const segmentMealData = mealAncillaries.segmentWiseAncillaryData[segmentKey]

    if (!Array.isArray(segmentMealData)) {
        return null
    }

    for (const mealInfo of segmentMealData) {
        if (mealInfo?.code === mealCode) {
            return mealInfo
        }
    }

    return null
}
